module.exports = __webpack_public_path__ + "static/media/Designer-Kaung-Myat.def8f56e.png";